<template>
  <div :class="[{disabled : disabledText !== undefined}, 'dual-selectbox-container']">
    <div class="disabled-text" v-if="disabledText !== undefined">
      <alert :size="20" /> <span class="text">{{ disabledText }}</span></div>
    <div class="left-part">
      <simple-form-input
        type="text"
        :label="$t('general.search')"
        v-model="filter"
      >
        <template v-slot:leadingIcon><search-icon :size="18" /></template>
      </simple-form-input>
      <ul class="options-container slim-scroll">
        <li
          v-for="option in items"
          :key="option.ticker"
          :class="[
            { active: selectedItems.includes(option.ticker) },
            'list-item',
          ]"
          @click="addToActive(option.ticker)"
        >
          <img
            :src="option.icon"
            class="ticker-logo"
            v-if="option.icon !== ''"
            @error="hasLogo = false"
          />
          <gradient-icon class="ticker-logo" :ticker="option.ticker" v-else />
          <span class="ticker-title">{{ option.ticker }}</span>
        </li>
      </ul>
    </div>
    <div class="button-box">
      <b-button variant="primary" @click="selectItems()"
        ><arrow-right :size="20" />
      </b-button>
      <b-button variant="primary" @click="putBackItems()"
        ><arrow-left :size="20" />
      </b-button>
    </div>
    <b-table
      sticky-header
      selectable
      select-mode="multi"
      :items="portfolioItems"
      :fields="fields"
      @row-selected="onRowSelected"
    >
      <template #cell(value)="data">
        <simple-form-input
          v-model="data.item.value"
          type="number"
          v-on:input="portfolioChange"
          noMessage
        />
      </template>
    </b-table>
  </div>
</template>
<script>
import Alert from "vue-material-design-icons/AlertOutline";
import ArrowLeft from "vue-material-design-icons/ArrowLeft";
import ArrowRight from "vue-material-design-icons/ArrowRight";
import GradientIcon from "../GradientIcon.vue";
import SearchIcon from "vue-material-design-icons/Magnify";
import SimpleFormInput from "./SimpleFormInput.vue";
export default {
  name: "DualSelectBox",
  components: {
    Alert,
    ArrowLeft,
    ArrowRight,
    GradientIcon,
    SearchIcon,
    SimpleFormInput,
  },
  props: {
    options: Array,
    fields: Array,
    initialItems: Array,
    disabledText:{
      type: String,
      required: false
    }
  },
  data() {
    return {
      selectedItems: [],
      portfolioItems: [],
      filter: "",
      filterItems: [],
      deleteItems: [],
    };
  },
  computed: {
    items() {
      let filtered = this.options;
      if (this.filterItems.length !== 0) {
        filtered = filtered.filter((o) =>
          Object.keys(o).some(
            (k) => k === "ticker" && this.filterItems.indexOf(o[k]) === -1
          )
        );
      }
      if (this.filter !== "") {
        filtered = filtered.filter((o) =>
          Object.keys(o).some(
            (k) =>
              k === "ticker" &&
              o[k].toLowerCase().includes(this.filter.toLowerCase())
          )
        );
      }
      return filtered;
    },
  },
  methods: {
    addToActive(ticker) {
      if (this.selectedItems.includes(ticker)) {
        const index = this.selectedItems.indexOf(ticker);
        this.selectedItems.splice(index, 1);
      } else {
        this.selectedItems.push(ticker);
      }
    },
    selectItems() {
      this.filterItems = this.filterItems.concat(this.selectedItems);
      for (var i = 0; i < this.selectedItems.length; i++) {
        const obj = {
          ticker: this.selectedItems[i],
          value: 0,
        };
        this.portfolioItems.push(obj);
      }
      this.selectedItems = [];
    },
    onRowSelected(items) {
      const selected = [];
      for (var i = 0; i < items.length; i++) {
        selected.push(items[i].ticker);
      }
      this.deleteItems = selected;
    },
    putBackItems() {
      this.filterItems = this.filterItems.filter(
        (item) => this.deleteItems.indexOf(item) === -1
      );
      this.portfolioItems = this.portfolioItems.filter(
        (item) => !this.deleteItems.includes(item.ticker)
      );
      this.deleteItems = [];
    },
    portfolioChange() {
      this.$emit("fillPortfolioData", this.portfolioItems);
    },
  },
  watch: {
    portfolioItems() {
      this.portfolioChange();
    },
    fields() {
      this.portfolioChange();
    },
    initialItems() {
      if (this.initialItems) {
        this.portfolioItems = this.initialItems;
      }
    },
    options() {
      this.portfolioItems = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.dual-selectbox-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  &.disabled{
    position: relative;
    .disabled-text{
      position: absolute;
      top: 25%;
      width: 100%;
      font-weight: 500;
      font-size: 16px;
      z-index: 2;
      display: flex;
      justify-content: center;
      color: #18125B;
      .text{
        margin-left: toRem(5);
        margin-top: toRem(3);
      }
    }
    .left-part, .button-box, .b-table-sticky-header{
      opacity: 0.2;
    }
  }
  .button-box {
    display: flex;
    flex-direction: column;
    .btn {
      margin-bottom: toRem(10);
      padding: 6px 10px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .left-part {
    width: 30%;
  }
}
.options-container {
  list-style-type: none;
  overflow-y: scroll;
  width: 100%;
  height: calc(50vh - 161px);
  margin-top: toRem(10);
  @include dps-box;
  padding: 0;
  padding-top: toRem(5);
  .list-item {
    display: flex;
    align-items: center;
    height: toRem(38);
    font-size: toRem(14);
    padding-left: toRem(20);
    // margin-bottom: toRem(5);
    font-weight: 500;
    cursor: pointer;
    &.active {
      background: #f1f3ff;
      color: #18125b;
    }
    .ticker-logo {
      border-radius: 50%;
      width: 1.5rem;
      height: 1.5rem;
      margin-right: toRem(5);
    }
  }
}
@media only screen and (max-height: 780px) {
  .dual-selectbox-container.disabled{
    .disabled-text{
      top: 0;
    }
  }
}
</style>